import axios from 'axios';
import { base_url } from '../../env';
import { getHeaders, parseAndShowMessage } from '../../store/common/common';
import { store } from '../../store/store';

import qs from 'qs';
import Geocode from 'react-geocode';

import actionTypes from './Company.actionTypes';

Geocode.setApiKey('AIzaSyADo-Lidh5uCF392j79_-pooszeTD83mj4');

axios.defaults.baseURL = base_url;
axios.interceptors.request.use(
  function (options) {
    options.headers = getHeaders();
    options.paramsSerializer = function (params) {
      return qs.stringify(params);
    };
    return options;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const companyActions = {
  ...actionTypes,

  // ACTIONS
  getAll:
    (params = null) =>
    (dispatch) => {
      dispatch({ type: companyActions.FETCHING });
      let query = {
        model: 'Company',
        queries: [
          {
            field: 'client_id',
            value: store.getState().login.user.client_id,
          },
        ],
      };
      axios
        .post(base_url + 'companies/overview', params)
        .then((response) =>
          dispatch({
            type: companyActions.FETCH_ALL_SUCCESS,
            payload: response.data,
          }),
        )
        .catch((error) =>
          dispatch({ type: companyActions.ERROR, payload: error }),
        );
    },
  getById: (id) => async (dispatch) => {
    dispatch({ type: companyActions.FETCHING });
    let lat = '';
    let lng = '';

    try {
      const { data } = await axios.get(`${base_url}resources/company/${id}`);

      try {
        const geocodeResponse = await Geocode.fromAddress(
          `${data.address} ${data.city} ${data.state} ${data.zip}`,
        );
        lat = geocodeResponse.results[0]?.geometry?.location?.lat ?? '';
        lng = geocodeResponse.results[0]?.geometry?.location?.lng ?? '';
      } catch (geocodeError) {
        console.warn('Geocoding company address failed', geocodeError);
      }

      dispatch({
        type: companyActions.FETCH_ONE_SUCCESS,
        payload: { ...data, lat, lng },
      });
    } catch (error) {
      dispatch({ type: companyActions.ERROR, payload: error });
    }
  },
  getByModel: (model, modelId) => (dispatch) => {
    dispatch({ type: companyActions.FETCHING });

    axios
      .get(base_url + `company/${model}/${modelId}`)
      .then((response) =>
        dispatch({
          type: companyActions.SUCCESS,
          payload: response.data,
        }),
      )
      .catch((error) =>
        dispatch({ type: companyActions.ERROR, payload: error }),
      );
  },
  delete: (id) => (dispatch) => {
    dispatch({ type: companyActions.DELETING });

    axios
      .delete(base_url + `company/${id}`)
      .then((response) =>
        dispatch({
          type: companyActions.DELETE_SUCCESS,
          payload: response.data,
        }),
      )
      .catch((error) =>
        dispatch({ type: companyActions.ERROR, payload: error }),
      );
  },
  update: (id, data) => (dispatch) => {
    dispatch({ type: companyActions.UPDATING });

    axios
      .put(base_url + `company/${id}`, data)
      .then((response) => {
        parseAndShowMessage('success', response, 'Company Update');
        dispatch({
          type: companyActions.UPDATING_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        parseAndShowMessage('error', error, 'Company Update');
        dispatch({ type: companyActions.ERROR, payload: error });
      });
  },
};

export default companyActions;
